import * as React from "react";
import { Stack, Text, PrimaryButton } from "office-ui-fabric-react";
import { Card } from "@uifabric/react-cards";
import { GS } from "../../utils/Styles";
export interface ErrorBoundaryProps {}

export interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }
  static getDerivedStateFromError(error:any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  componentDidCatch(error:any, errorInfo:any) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Stack horizontalAlign="center" verticalAlign="center" verticalFill={true}>
          <Stack.Item>
            <br />
            <Card className="padding-16" horizontal styles={{ root: { width: 315, ...GS.bgWhite, display: "flex", flexDirection: "column", justifyContent: "center" } }}>
              <Card.Item styles={{ root: { alignSelf: "center" } }}>
                <Text variant="xxLargePlus">Some thing went wrong</Text>
              </Card.Item>
              <br />
              <Card.Item styles={{ root: { alignSelf: "center" } }}>
                <PrimaryButton label="home" href="/" color="primary" aria-label="home">
                  Home
                </PrimaryButton>
              </Card.Item>
            </Card>
          </Stack.Item>
        </Stack>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
